module.exports = __webpack_public_path__ + "img/gonetwork2_icon4.9e9039ee.png";